import {CircularProgress, CircularProgressProps} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, {FunctionComponent} from 'react';

const useStyles = makeStyles({
   root: {
      display: 'flex',
      justifyContent: 'center',
   },
   inline: {
      display: 'inline-block',
      '&>div': {
         verticalAlign: 'text-top',
      },
   },
});

const Loader: FunctionComponent = () => {
   const classes = useStyles();
   return (
      <div className={classes.root}>
         <CircularProgress size="3rem" disableShrink />
      </div>
   );
};

export const LoaderInline = (props: CircularProgressProps) => {
   const classes = useStyles();
   return (
      <div className={classes.inline}>
         <CircularProgress size="1rem" disableShrink {...props} />
      </div>
   );
};

export default Loader;
